import { styled, theme } from 'twin.macro'

export const StyledBottomBar = styled.div`
  max-width: 1168px;

  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0 auto;

  .bottomBar {
    position: relative;
    z-index: 3;
    width: 100%;
    background-color: #fff;
    box-shadow: 0 -2px 7px 0 rgba(0, 0, 0, 0.09);
    padding-bottom: constant(safe-area-inset-bottom, 0);
    padding-bottom: env(safe-area-inset-bottom, 0);
  }
  .bottomBar ~ .downloadBar {
    bottom: 49px;
  }
  .bottomBar.bottomBarReply {
    width: 100%;

    @media (min-width: ${theme`screens.lg`}) {
      width: calc(100% * 668 / 1168);
      left: calc(100% * 100 / 1168);
    }
  }
  .bottomBar .bottomBar__cols {
    display: flex;
    list-style: none;
    margin: 0 auto;
    padding: 0;
    text-align: center;
    max-width: 600px;
  }
  .bottomBar .bottomBar__cols .bottomBar__col {
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
    float: left;
    margin: 15px 0;
    color: #666;
    font-size: 0.8em;
    cursor: pointer;
    height: 18px;
  }
  .bottomBar .bottomBar__cols .bottomBar__col:not(:last-child) {
    border-right: 0.5px solid;
    border-right-color: #eee;
  }
  .bottomBar .bottomBar__cols .bottomBar__col > span {
    display: inline-block;
    vertical-align: middle;
    margin: 0 2px;
  }
  .bottomBar .bottomBar__cols:not(.bottomBar__post) {
    overflow: auto;
  }
  .bottomBar .icon {
    width: 18px;
    height: 18px;
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    display: inline-block;
  }
  .bottomBar .icon.icon--reply {
    background-image: url('/statics/images/icon/comment@3x.png');
  }
  .bottomBar .replyBar {
    display: flex;
    align-items: center;
    list-style: none;
    overflow: hidden;
    text-align: center;
    max-width: 600px;
    margin: 0 auto;
    padding: 10px 0;
  }
  .bottomBar .replyBar * {
    box-sizing: content-box;
  }
  .bottomBar .replyBar::before {
    content: '';
    height: 100%;
    display: inline-block;
    vertical-align: middle;
  }
  .bottomBar .replyBar .replyBar__send {
    flex: 1 1 auto;
    align-self: stretch;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    position: relative;
    width: 40px;
    margin-left: 65px;
    color: #838eff;
    vertical-align: middle;
    cursor: pointer;
  }
  .bottomBar .replyBar .replyBar__textareaWrapper {
    flex: 0 0 auto;
    position: relative;
    display: inline-block;
    vertical-align: middle;
    width: calc(100% - 135px);
    font-size: 1em;
    border-radius: 20px;
    outline: 0 none;
    border-color: #ccc;
  }
  .bottomBar .replyBar .replyBar__textarea {
    display: block;
    overflow: hidden;
    width: 100%;
    height: 1.8em;
    border-radius: 20px;
    border-color: #ccc;
    padding: 2px 45px 2px 12px;
    font-size: 16px;
    line-height: 1.8em;
    outline: 0 none;
    appearance: none;
    resize: none;
  }
  .bottomBar .replyBar .replyBar__uploadImg {
    width: 30px;
    height: 100%;
    overflow: hidden;
    background-position: center;
    background-repeat: no-repeat;
    cursor: pointer;
    background-image: url('/statics/images/icon/camera@3x.png');
    position: absolute;
    top: 50%;
    right: -60px;
    transform: translateY(-50%) translateY(-2px);
    margin: 2px 10px 10px;
    background-size: 24px;
  }
  .bottomBar .replyBar .replyBar__uploadImg ~ input {
    display: none;
  }
`
